import React from "react";
import { connect } from "react-redux";
import { logout } from "../actions/userActions";
import { NavItemMaterial } from "../components/nav/NavItemMaterial";

class Logout extends React.Component {
  render() {
    return (
      !this.props.anonymousAutologin && (
        <NavItemMaterial
          icon="exit_to_app"
          text={
            this.props.isAnonymous === false ? this.props.text : this.props.exit
          }
          onClick={this.props.logout}
        />
      )
    );
  }
}

const mapStateToProps = state => {
  return {
    isAnonymous: state.user.anonymous,
    anonymousAutologin: state.config.mode.anonymous_autologin,
    exit: state.config.text("settings.logout.anonymous"),
    text: state.config.text("settings.logout"),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => {
      dispatch(logout());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Logout);






// WEBPACK FOOTER //
// ./src/containers/Logout.js